import React from 'react';

interface IProps {
  isActingOpen: boolean;
}

const ActingRouteMapLegend: React.FC<IProps> = ({ isActingOpen }) => (
  <div
    className="flex flex-wrap gap-x-4 gap-y-2 text-xs text-muted-foreground"
    aria-label="Legenda do mapa"
  >
    <span className="flex items-center gap-1.5">
      <span className="w-5 border-t-2 border-dashed border-blue-600" /> Rota
      planejada
    </span>
    <span className="flex items-center gap-1.5">
      <span className="w-5 border-t-4 border-primary" /> Traçado analisado
    </span>
    <span className="flex items-center gap-1.5">
      <span className="size-2.5 rounded-full bg-slate-900" /> Início
    </span>
    <span className="flex items-center gap-1.5">
      <span className="size-2.5 rounded-full bg-primary" />
      {isActingOpen ? 'Posição atual analisada' : 'Fim'}
    </span>
    <span className="flex items-center gap-1.5">
      <span className="size-2.5 rounded-full bg-emerald-600" /> Embarque
    </span>
    <span className="flex items-center gap-1.5">
      <span className="size-2.5 rounded-full bg-orange-600" /> Desembarque
    </span>
  </div>
);

export default ActingRouteMapLegend;
